
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

saveQueryParams();

var globalDataSave = "";

if(document.querySelector(".slider-wrapper")){
  window.onload = function(){
    slideOne();
    slideTwo();
  }

  let sliderOne = document.getElementById("slider-1");
  let sliderOneInput = document.getElementById("slider-1-input");
  let sliderTwo = document.getElementById("slider-2");
  let sliderTwoInput = document.getElementById("slider-2-input");
  let displayValOne = document.getElementById("range1");
  let displayValTwo = document.getElementById("range2");
  let minGap = 0;
  let sliderTrack = document.querySelector(".slider-track");
  let sliderMaxValue = document.getElementById("slider-1").max;

  if(sliderOneInput){
    sliderOneInput.addEventListener("keyup", function(e){
      if(this.value < 0){
        this.value = 0;
      }
      else if(this.value > 2000){
        this.value = 2000;
      }
      else{
        sliderOne.value = this.value;
        slideOne();
      }
    });
  }
  if(sliderTwoInput){
    sliderTwoInput.addEventListener("keyup", function(e){
      if(this.value < 0){
        this.value = 0;
      }
      else if(this.value > 2000){
        this.value = 2000;
      }
      else{
        sliderTwo.value = this.value;
        slideTwo();
      }
    });
  }
  if(document.querySelector(".filter-item.price .reset-button")){
    document.querySelector(".filter-item.price .reset-button").addEventListener("click", function(e){
      document.querySelector(".filter-item.price .slider-container #slider-1").value = parseInt(document.querySelector(".filter-item.price .slider-container #slider-1").min);
      document.querySelector(".filter-item.price .slider-container #slider-2").value = parseInt(document.querySelector(".filter-item.price .slider-container #slider-2").max);
      slideOne();
      slideTwo();
    });
  }
  if(document.querySelector(".filter-holder:not(.my-list) .filter-item.price .slider-container #slider-1") && Shopify.queryParams["filter.v.price.gte"]){
    document.querySelector(".filter-holder:not(.my-list) .filter-item.price .slider-container #slider-1").value = Shopify.queryParams["filter.v.price.gte"];
    document.querySelector(".filter-holder:not(.my-list) .filter-item.price #slider-1-input").value = Shopify.queryParams["filter.v.price.gte"];
  }
  if(document.querySelector(".filter-holder:not(.my-list) .filter-item.price .slider-container #slider-2") && Shopify.queryParams["filter.v.price.lte"]){
    document.querySelector(".filter-holder:not(.my-list) .filter-item.price .slider-container #slider-2").value = Shopify.queryParams["filter.v.price.lte"];
    document.querySelector(".filter-holder:not(.my-list) .filter-item.price #slider-2-input").value = Shopify.queryParams["filter.v.price.lte"];
  }

  if(document.querySelector(".filter-holder:not(.my-list) .filter-item.price .apply-button")){
    document.querySelector(".filter-holder:not(.my-list) .filter-item.price .apply-button").addEventListener("click", function(e){
      var min = document.querySelector(".filter-holder:not(.my-list) .filter-item.price .slider-container #slider-1").value;
      var max = document.querySelector(".filter-holder:not(.my-list) .filter-item.price .slider-container #slider-2").value;
      Shopify.queryParams["filter.v.price.gte"] = min;
      Shopify.queryParams["filter.v.price.lte"] = max;
      Shopify.queryParams["page"] = 1;
      var search = new URLSearchParams(Shopify.queryParams).toString();
      location.search = search.replaceAll("%2C",",");
    });
  }

  function slideOne(){
    if(parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap){
      sliderOne.value = parseInt(sliderTwo.value) - minGap;
      // sliderOneInput.value = parseInt(sliderTwo.value) - minGap;
    }
    sliderOneInput.value = sliderOne.value;
    displayValOne.textContent = "$"+(sliderOne.value);
    fillColor();
  }
  function slideTwo(){
    if(parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap){
      sliderTwo.value = parseInt(sliderOne.value) + minGap;
      // sliderTwoInput.value = parseInt(sliderOne.value) + minGap;
    }
    sliderTwoInput.value = sliderTwo.value;
    displayValTwo.textContent = "$"+(sliderTwo.value);
    fillColor();
  }
  function fillColor(){
    percent1 = (sliderOne.value / sliderMaxValue) * 100;
    percent2 = (sliderTwo.value / sliderMaxValue) * 100;
    sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #ec0000 ${percent1}% , #ec0000 ${percent2}%, #dadae5 ${percent2}%)`;
  }
}
if(document.querySelector(".card-information .card-information__wrapper .add-button-holder .input-holder input")){
  document.querySelectorAll(".card-information .card-information__wrapper .add-button-holder .input-holder input").forEach(function(quantity_input){
    quantity_input.addEventListener("keyup", function(e){
      bindQuantityChange(e);
    });
    function bindQuantityChange(e){
      var increment = parseInt(e.target.getAttribute("data-increment-amount"));
      var quantity_value = parseInt(parseInt(e.target.value)/increment);
      var unit = e.target.getAttribute("data-increment-unit");
      var max_value = $(e.target.closest(".bottom-holder").querySelector(".variant-options-holder .variant-option input:checked")).data("max");
      quantity_value = parseFloat((quantity_value+"").replace(/[^0-9]/g, ''));
      if(max_value == null){
        max_value = Number.POSITIVE_INFINITY;
      }
      else{
        max_value = parseInt(max_value);
      }
      if(isNaN(quantity_value)){
        if(e.target.value != ""){
          quantity_value = 1;
          e.target.value = (quantity_value*parseInt(increment))+unit;
        }
      }
      else{
        if(quantity_value > max_value){
          quantity_value = max_value;
        }
        if(quantity_value < 1){
          quantity_value = 1;
        }
        e.target.value = (quantity_value*increment)+unit;
      }
    }
  });
}

if(document.querySelector(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder input")){
  document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder input").forEach(function(quantity_input){
    quantity_input.addEventListener("keyup", function(e){
      bindQuantityChangeProduct(e);
    });
    function bindQuantityChangeProduct(e){
      var increment = parseInt(e.target.getAttribute("data-increment-amount"));
      var quantity_value = parseInt(parseInt(e.target.value)/parseInt(increment));
      var unit = e.target.getAttribute("data-increment-unit");
      var max_value = $(e.target.closest(".main-actions-holder").querySelector(".uom-selector .variant-options-holder .variant-option input:checked")).data("max");
      quantity_value = parseFloat((quantity_value+"").replace(/[^0-9]/g, ''));
      if(max_value == null){
        max_value = Number.POSITIVE_INFINITY;
      }
      else{
        max_value = parseInt(max_value);
      }
      if(isNaN(quantity_value)){
        if(e.target.value != ""){
          quantity_value = 1;
          e.target.value = (quantity_value*parseInt(increment))+unit;
        }
      }
      else{
        if(quantity_value > max_value){
          quantity_value = max_value;
        }
        if(quantity_value < 1){
          quantity_value = 1;
        }
        e.target.value = (quantity_value*increment)+unit;
      }
    }
  });
}

if(document.querySelector(".card-information .card-information__wrapper .quantity-buttons-holder .quantity-button")){
  document.querySelectorAll(".card-information .card-information__wrapper .quantity-buttons-holder .quantity-button").forEach(function(quantity_button){
    quantity_button.addEventListener("click", function(e){
      var increment = parseFloat(e.target.closest(".input-holder").querySelector("input").getAttribute("data-increment-amount"));
      var quantity_value = parseInt(parseInt(e.target.closest(".input-holder").querySelector("input").value)/increment);
      var unit = e.target.closest(".input-holder").querySelector("input").getAttribute("data-increment-unit");
      var max_value = $(e.target.closest(".bottom-holder").querySelector(".variant-options-holder .variant-option input:checked")).data("max");
      if(max_value == null){
        max_value = Number.POSITIVE_INFINITY;
      }
      else{
        max_value = parseInt(max_value);
      }
      quantity_value = parseFloat(quantity_value);
      if(!/^\d+$/.test(quantity_value)){
        quantity_value = 1;
      }
      else{
        quantity_value = parseInt(quantity_value);
        if(e.target.classList.contains("up")){
          if(quantity_value + 1 <= max_value){
            quantity_value++;
          }
        }
        else if(e.target.classList.contains("down")){
          if(quantity_value - 1 > 0){
            quantity_value--;
          }
        }
      }
      e.target.closest(".input-holder").querySelector("input").value = (quantity_value*increment)+unit;
    });
  });
}

if(document.querySelector(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder .quantity-button")){
  document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder .quantity-button").forEach(function(quantity_button){
    quantity_button.addEventListener("click", function(e){
      var increment = parseFloat(e.target.closest(".quantity-holder").querySelector("input").getAttribute("data-increment-amount"));
      var quantity_value = parseInt(parseInt(e.target.closest(".quantity-holder").querySelector("input").value)/increment);
      var unit = e.target.closest(".quantity-holder").querySelector("input").getAttribute("data-increment-unit");
      var max_value = $(e.target.closest(".main-actions-holder").querySelector(".uom-selector .variant-options-holder .variant-option input:checked")).data("max");
      if(max_value == null){
        max_value = Number.POSITIVE_INFINITY;
      }
      else{
        max_value = parseInt(max_value);
      }
      quantity_value = parseFloat(quantity_value);
      if(!/^\d+$/.test(quantity_value)){
        quantity_value = 1;
      }
      else{
        quantity_value = parseInt(quantity_value);
        if(e.target.classList.contains("up")){
          if(quantity_value + 1 <= max_value){
            quantity_value++;
          }
        }
        else if(e.target.classList.contains("down")){
          if(quantity_value - 1 > 0){
            quantity_value--;
          }
        }
      }
      e.target.closest(".quantity-holder").querySelector("input").value = (quantity_value*increment)+unit;
    });
  });
}

if(document.querySelector(".filter-holder:not(.my-list) .filter-item.brands .buttons-holder.brands .reset-button")){
  document.querySelector(".filter-holder:not(.my-list) .filter-item.brands .buttons-holder.brands .reset-button").addEventListener("click", function(e){
    Shopify.queryParams["filter.p.vendor"] = "";
    var search = new URLSearchParams(Shopify.queryParams).toString();
    location.search = search.replaceAll("%2C",",");
  });
}
if(document.querySelector(".filter-holder:not(.my-list) .filter-item.availability .stock-list .stock-item input")){
  if(Shopify.queryParams["filter.v.availability"] && Shopify.queryParams["filter.v.availability"] == 1){
    document.querySelector(".filter-holder:not(.my-list) .filter-item.availability .stock-list .stock-item input").checked = true;
  }
  document.querySelector(".filter-holder:not(.my-list) .filter-item.availability .stock-list .stock-item input").addEventListener("change", function(e){
    if(e.target.checked){
      Shopify.queryParams["filter.v.availability"] = 1;
    }
    else{
      Shopify.queryParams["filter.v.availability"] = "";
    }
    var search = new URLSearchParams(Shopify.queryParams).toString();
    location.search = search.replaceAll("%2C",",");
  });
}
if(document.querySelector(".filter-holder:not(.my-list) .filter-item.brands .brands-list .brand-item input")){
  document.querySelectorAll(".filter-holder:not(.my-list) .filter-item.brands .brands-list .brand-item input").forEach(function(brand){
    brand.addEventListener("change", function(e){
      var checked_brands = [];
      document.querySelectorAll(".filter-holder:not(.my-list) .filter-item.brands .brands-list .brand-item input").forEach(function(selected_brand){
        if(selected_brand.checked){
          checked_brands.push(selected_brand.attributes["data-brand"].value);
        }
      });
      Shopify.queryParams["filter.p.vendor"] = [...new Set(checked_brands)].join();
      Shopify.queryParams["page"] = 1;
      var search = new URLSearchParams(Shopify.queryParams).toString();
      location.search = search.replaceAll("%2C",",");
    });
  });
  if(Shopify.queryParams["filter.p.vendor"]){
    var brands_data = Shopify.queryParams["filter.p.vendor"].replaceAll("+"," ").split(",");
    brands_data.forEach(function(brand){
      document.querySelector('.filter-holder:not(.my-list) .filter-item.brands .brands-list .brand-item input[data-brand="'+brand+'"]').checked = true;
    });
  }
}
if(document.querySelector(".filter-holder:not(.my-list) .filter-item.types .types-list .type-item input")){
  document.querySelectorAll(".filter-holder:not(.my-list) .filter-item.types .types-list .type-item input").forEach(function(type){
    type.addEventListener("change", function(e){
      var checked_types = [];
      document.querySelectorAll(".filter-holder:not(.my-list) .filter-item.types .types-list .type-item input").forEach(function(selected_type){
        if(selected_type.checked){
          checked_types.push(selected_type.attributes["data-type"].value);
        }
      });
      Shopify.queryParams["filter.p.type"] = [...new Set(checked_types)].join();
      Shopify.queryParams["page"] = 1;
      var search = new URLSearchParams(Shopify.queryParams).toString();
      location.search = search.replaceAll("%2C",",");
    });
  });
  if(Shopify.queryParams["filter.p.type"]){
    var types_data = Shopify.queryParams["filter.p.type"].replaceAll("+"," ").split(",");
    types_data.forEach(function(type){
      document.querySelector('.filter-holder:not(.my-list) .filter-item.types .types-list .type-item input[data-type="'+type+'"]').checked = true;
    });
  }
}

document.addEventListener('touchstart', function(){}, {passive: true});
document.addEventListener('touchmove', function(){}, {passive: true});
document.addEventListener('wheel', function(){}, {passive: true});
document.addEventListener('mousewheel', function(){}, {passive: true});
enableSort();
bind();

$(document).ready(function(){
  enableMainBanner();
  enableSalesCollectionProductsScroll();
  enableBrandsScroll();
  enableCollectionIconsScroll();
  enableRecommendedScroll();
  enableTestimonialsScroll();
  enableAboutUsLocationScroll();
  // enableMobileSearch();
  enablePopupCart();
  bindAddToCart();
  bindDeleteItemFromCartPopup();
  bindCartQuantityInput();
  bindCartQuantityButton();
  bindFiltersPopup();
  bindContinueButton();
  // updateNoteandRedirectToCheckout();
  updateNoteandRedirectToCheckout2();
  enableProductImagesScroll();
  addSeeMoreProductDescription();
  addSeeMoreProductDisclaimers();
  showMegaMenuMobile();
  showChildMenuMobile();
  clearMenuMobile();
  showLoginPopup();
  showAddressEditForm();
  showNewAddressForm();
  accountMenuShow();
  clearAccountMenu();
  loadListProducts();
  toggleOrders();
  applyListFilters();
  toggleFAQs();
  toggleCitiesDropdown();
  enabledLocationsCarousel();
  businessCategoryChange();
  attachCatalogueFile();
  triggerSearch();
  togglePickupOption();
  // checkFreeProducts();
  onVariantOptionChange();
  checkMax();
});

var current_quantity = 0;

function onVariantOptionChange(){
  $(document).on("change",".variant-options-holder .variant-option input",function(){
    $(this).closest(".bottom-holder").find(".add-button-holder .input-holder input").val(1);
    $(this).closest(".main-actions-holder").find(".action-holder .quantity-holder input").val(1);
    checkMax();
  })
}

function togglePickupOption(){
  $(document).on("change",".pickup-form .input-field.date-picker",function(){
    pickupSlotSetter(this);
  });
  $(document).on("click",".pickup-holder .pickup-details-holder .purchase-option",function(){
    if(!$(this).hasClass("active")){
      if($(this).hasClass("delivery-option")){
        $(".box-form").addClass("disabled");
        $(".pickup-form").addClass("disabled");
        $(".delivery-form").removeClass("disabled");
      }
      else if($(this).hasClass("box-option")){
        $(".pickup-form").addClass("disabled");
        $(".delivery-form").addClass("disabled");
        $(".box-form").removeClass("disabled");
      }
      else{
        if(($(".total-value").data("total-price")/100) >= 250){
	      $(".box-form").addClass("disabled");
	      $(".delivery-form").addClass("disabled");
          $(".pickup-form").removeClass("disabled");
        }
        else{
          showNotification("Cart value must be greater than $250 for pickup!","error");
          return;
        }
      }
      $(".pickup-holder .pickup-details-holder .purchase-option").removeClass("active");
      $(this).addClass("active");
    }
  });
}

function pickupSlotSetter(picker){
  var date = new Date();
  var current_date = ((date.getMonth()+1).toString().length == 1 ? "0"+(date.getMonth()+1).toString() : (date.getMonth()+1).toString()) + "-" + (date.getDate().toString().length == 1 ? "0"+(date.getDate()).toString() : (date.getDate()).toString()) + "-" + (date.getFullYear());
  var disable = [];
  var make_active = "12:00 PM";
  var make_active_index = 1;
  $(".pickup-form .time-picker")[0].removeAttribute("disabled");
  if(picker.value == current_date){
    if((((new Date().getHours()).toString().length == 1) ? "0"+(new Date().getHours()) : (new Date().getHours()).toString())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" < "9:00:00"){
      disable = [];
      make_active_index = 1;
      make_active = "12:00 PM";
    }
    if((((new Date().getHours()).toString().length == 1) ? "0"+(new Date().getHours()) : (new Date().getHours()).toString())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" > "9:00:00"){
      disable = [1];
      make_active_index = 2;
      make_active = "01:00 PM";
    }
    if((((new Date().getHours()).toString().length == 1) ? "0"+(new Date().getHours()) : (new Date().getHours()).toString())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" > "10:00:00"){
      disable = [1,2];
      make_active_index = 3;
      make_active = "02:00 PM";
    }
    if((((new Date().getHours()).toString().length == 1) ? "0"+(new Date().getHours()) : (new Date().getHours()).toString())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" > "11:00:00"){
      disable = [1,2,3];
      make_active_index = 4;
      make_active = "03:00 PM";
    }
    if((((new Date().getHours()).toString().length == 1) ? "0"+(new Date().getHours()) : (new Date().getHours()).toString())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" > "12:00:00"){
      disable = [1,2,3,4];
      make_active_index = 5;
      make_active = "04:00 PM";
    }
    if((((new Date().getHours()).toString().length == 1) ? "0"+(new Date().getHours()) : (new Date().getHours()).toString())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" > "13:00:00"){
      disable = [1,2,3,4,5];
      make_active_index = 0;
      make_active = "";
    }
    // else if((new Date().getHours())+":"+(new Date().getMinutes().length == 1 ? ("0"+new Date().getMinutes()).toString() : (new Date().getMinutes()).toString())+":00" > "8:00:00"){
    //   disable = [1];
    //   make_active_index = 2;
    //   make_active = "12:00 PM";
    // }
    for(var i = 0; i < $(".pickup-form .time-picker option").length; i++){
      if(disable.includes(i)){
        $(".pickup-form .time-picker option")[i].disabled = true;
      }
    }
    $(".pickup-form .time-picker option")[make_active_index].selected = true;
    $(".pickup-form .time-picker").val(make_active);
  }
  else{
    for(var i = 0; i < $(".pickup-form .time-picker option").length; i++){
      $(".pickup-form .time-picker option")[i].disabled = false;
    }
    $(".pickup-form .time-picker option")[1].selected = true;
    $(".pickup-form .time-picker").val("12:00 PM");
    // $(".pickup-form .time-picker option")[1].val("12:00 PM");
    // $(".pickup-form .time-picker option")[2].val("01:00 PM");
    // $(".pickup-form .time-picker option")[3].val("02:00 PM");
    // $(".pickup-form .time-picker option")[4].val("03:00 PM");
    // $(".pickup-form .time-picker option")[5].val("04:00 PM");
  }
}

function triggerSearch(){
  $(document).on("click",".predictive-search__list-item button[type='submit']",function(){
    $(".search-bar__submit").click();
  });
}

function attachCatalogueFile(){
  $(document).on("click",".main-form.catalogue .add-catalogue",function(){
    $(".main-form.catalogue .catalogue-file").click();
  });
  $(document).on("change",".main-form.catalogue .catalogue-file",function(){
    $(".main-form.catalogue .add-catalogue").html(this.value.split("\\")[this.value.split("\\").length - 1]);
  });
}

function toggleFAQs(){
  $(".faqs-section .faq-groups-holder .faq-group .faq-group-questions .faq-item .faq-answer").slideUp(1);
  $(document).on("click",".faqs-section .faq-groups-holder .faq-group .faq-group-questions .faq-item .faq-question",function(){
    $(this).closest(".faq-item").toggleClass("active");
    if($(this).closest(".faq-item").hasClass("active")){
      $(this).closest(".faq-item").find(".faq-answer").slideDown(300);
    }
    else {
      $(this).closest(".faq-item").find(".faq-answer").slideUp(300);
    }
  });
}

function addSeeMoreProductDescription(){
  if($(".product-data-holder .right-data-holder .description-section.description .product-description")){
    if($(".product-data-holder .right-data-holder .description-section.description .product-description").outerHeight() > 474){
      $(".product-data-holder .right-data-holder .description-section.description").addClass("extra-margin");
      $(".product-data-holder .right-data-holder .description-section.description .product-description-outer").animate( { height: "450px" }, { queue:false, duration:300 });
      $(".product-data-holder .right-data-holder .description-section.description").append("<div class='see-more'>See More</div>");
      $(document).on("click",".product-data-holder .right-data-holder .description-section.description .see-more",function(){
        if(!$(this).hasClass("expanded")){
          $(".product-data-holder .right-data-holder .description-section.description .product-description-outer").animate( { height: $(".product-data-holder .right-data-holder .description-section.description .product-description").outerHeight() }, { queue:false, duration:300 });
          $(this).html("See Less");
        }
        else{
          $(".product-data-holder .right-data-holder .description-section.description .product-description-outer").animate( { height: "450px" }, { queue:false, duration:300 });
          $(this).html("See More");
        }
        $(this).toggleClass("expanded");
      });
    }
  }
}

function addSeeMoreProductDisclaimers(){
  if($(".product-data-holder .right-data-holder .description-section.disclaimers .product-description")){
    if($(".product-data-holder .right-data-holder .description-section.disclaimers .product-description").outerHeight() > 109){
      $(".product-data-holder .right-data-holder .description-section.disclaimers .product-description-outer").animate( { height: "90px" }, { queue:false, duration:300 });
      $(".product-data-holder .right-data-holder .description-section.disclaimers").append("<div class='see-more'>See More</div>");
      $(document).on("click",".product-data-holder .right-data-holder .description-section.disclaimers .see-more",function(){
        if(!$(this).hasClass("expanded")){
          $(".product-data-holder .right-data-holder .description-section.disclaimers .product-description-outer").animate( { height: $(".product-data-holder .right-data-holder .description-section.disclaimers .product-description").outerHeight() }, { queue:false, duration:300 });
          $(this).html("See Less");
        }
        else{
          $(".product-data-holder .right-data-holder .description-section.disclaimers .product-description-outer").animate( { height: "90px" }, { queue:false, duration:300 });
          $(this).html("See More");
        }
        $(this).toggleClass("expanded");
      });
    }
  }
}

function applyListFilters(){
  $(document).on("change",".filter-holder.my-list .filter-item.availability .stock-item input",function(){
    listFilters();
  });
  $(document).on("click",".filter-holder.my-list .filter-item.price .buttons-holder .apply-button",function(){
    listFilters();
  });
  $(document).on("change",".filter-holder.my-list .filter-item.brands .brands-list .brand-item input",function(){
    listFilters();
  });
  // $(document).on("change",".sort-by-list",function(){
  //   listFilters();
  // });
}

function listFilters(){
  var showAvailable = $(".filter-holder.my-list .filter-item.availability .stock-item input")[0].checked
  var priceMin = parseInt($(".filter-holder.my-list .filter-item.price .slider-wrapper .slider-container #slider-1").val());
  var priceMax = parseInt($(".filter-holder.my-list .filter-item.price .slider-wrapper .slider-container #slider-2").val());
  var brands = [];
  var sortBy = $(".sort-by-list").val();
  document.querySelectorAll(".filter-holder.my-list .filter-item.brands .brands-list .brand-item input").forEach(function(brand){
    if(brand.checked){
      brands.push($(brand).data("brand"));
    }
  });
  $(".account-right-holder.list .products-holder").html(globalDataSave);
  document.querySelectorAll(".account-right-holder.list .products-holder .product-item").forEach(function(product){
    var remove = false;
    if(showAvailable && $(product).data("available") == false){
      remove = true;
    }
    if((parseInt($(product).data("price"))/100) > priceMax || (parseInt($(product).data("price"))/100) < priceMin){
      remove = true;
    }
    if(brands.length > 0 && !brands.includes($(product).data("brand"))){
      remove = true;
    }
    if(remove){
      $(product).remove();
    }
  });
  window._swat.initializeActionButtons('.products-holder', '.add_to_list');
  if(document.querySelectorAll(".account-right-holder.list .products-holder .product-item").length == 0){
    $(".account-right-holder.list .products-holder").html("<div class='none-added'>No products match the filters.</div>");
  }
}

function toggleOrders(){
  window.addEventListener('hashchange', function(){
    if (window.location.pathname === '/account' && window.location.hash === '#orders') {
      document.querySelector('.main-account-page.options').classList.remove("show");
      document.querySelector('.main-account-page.orders').classList.add("show");
    }
    else if (window.location.pathname === '/account' && window.location.hash === '') {
      document.querySelector('.main-account-page.options').classList.add("show");
      document.querySelector('.main-account-page.orders').classList.remove("show");
    }
  })
}
function loadListProducts(){
  if(location.pathname.includes("/pages/my-list")){
    loadListProductsCheck();
  }
}
function loadListProductsCheck(){
  setTimeout(function(){
    if(window._swat == undefined){
      loadListProductsCheck();
    }
    else{
      populateListProducts();
    }
  },500);
}
function populateListProducts(){
  window._swat.fetchWrtEventTypeET(
    function(r) {
      if(r.length > 0){
        r.forEach(function(item){
          $.ajax({url: item.du.split("?")[0]+"?view=collection-product-card", async: false, success: function(data){
            $(".account-right-holder .collection-holder .products-holder").append(data);
          }});
        });
        setTimeout(function(){
          window._swat.initializeActionButtons('.products-holder', '.add_to_list');
        },1000);
        var brands_list = [];
        $(".account-right-holder .products-holder .product-item").each(function(index, product){
          brands_list.push($(product).data("brand"));
        });
        brands_list = [...new Set(brands_list)];
        brands_list.forEach(function(brand){
          $(".filter-holder.my-list .filter-item.brands .brands-list").append('<div class="brand-item"> <label for="brand-'+brand+'"> <input type="checkbox" id="brand-'+brand+'" data-brand="'+brand+'" name="brands"> <span class="checkmark"></span> <span>'+brand+'</span> </label> </div>')
        });
        if(document.querySelector(".tier-discount-button")){
          document.querySelector(".account-right-holder.list .collection-holder .products-holder").classList.add("show-tiers");
        }
        globalDataSave = $(".account-right-holder.list .products-holder").html();
      }
      else{
        $(".main-account-page.list .account-data-holder .account-left-holder").remove();
        $(".main-account-page.list .account-data-holder").addClass("full-width");
        $(".account-right-holder.list .products-holder").html("<div class='none-added'>No products added to list.</div>");
      }
      $(".list-overlay-holder").removeClass("show");
      // $(".product-item .add_to_list").addClass("swym-added");
    },
    window._swat.EventTypes.addToWishList
  );
}

function clearAccountMenu(){
  if($("body").width() < 1024){
    $(".main-account-page .account-data-holder .account-left-holder .account-menu-holder .account-menu-item .account-menu-holder").slideUp(300);  
  }
  else{
    $(".main-account-page .account-data-holder .account-left-holder .account-menu-holder .account-menu-item").removeClass("active");
    $(".main-account-page .account-data-holder .account-left-holder .account-menu-holder .account-menu-item .account-menu-holder").slideDown(1);  
  }
}

function accountMenuShow(){
  $(document).on("click",".main-account-page .account-data-holder .account-left-holder .account-menu-holder .account-menu-item .account-menu-title", function(){
    if($("body").width() < 1024){
      $(this).closest(".account-menu-item").toggleClass("active");
      if($(this).closest(".account-menu-item").hasClass("active")){
        $(".main-account-page .account-data-holder .account-left-holder .account-menu-holder .account-menu-item .account-menu-holder").slideDown(300);
      }
      else{
        $(".main-account-page .account-data-holder .account-left-holder .account-menu-holder .account-menu-item .account-menu-holder").slideUp(300);
      }
    }
  });
}

function showNewAddressForm(){
  $(document).on("click",".account-data-holder .account-right-holder .addresses-title-holder .address-form-outer-holder .address-form-holder .close-address-popup,.account-data-holder .account-right-holder .addresses-title-holder .add-address-button", function(){
    $(".account-data-holder .account-right-holder .addresses-title-holder .address-form-outer-holder").toggleClass("show");
  });
}

function showAddressEditForm(){
  $(document).on("click",".account-data-holder .account-right-holder .addresses-holder .customer-address-holder .address-form-outer-holder .address-form-holder .close-address-popup, .account-data-holder .account-right-holder .addresses-holder .customer-address-holder .address-function-button.edit", function(){
    $("#"+$(this).data("edit-address-form")).toggleClass("show");
  });
  // $(document).on("click",".account-data-holder .account-right-holder .addresses-holder .customer-address-holder .address-function-button.delete", function(){
  //   if(confirm("Are you sure you wish to delete this address?")){
  //     var form_id = $(this).data("form-id");
  //     $.ajax({method: "POST", url: "/account/addresses/"+form_id, contentType: "application/json", data: {"_method": "delete"}, success: function(data){
  //       location.reload();
  //     }});
  //   }
  // });
}
function showMegaMenuMobile(){
  $(document).on("click",".main-bar .main-bar-data-holder .left-holder .menu-icon-holder", function(){
    $(this).toggleClass("active");
    $(".main-nav").toggleClass("active");
  });
}
function showLoginPopup(){
  $(document).on("click",".main-bar .main-bar-data-holder .right-holder .options .option.login-signup, .main-bar .main-bar-data-holder .right-holder .options .option.login-signup .login-popup .close-popup", function(e){
    $(".main-bar .main-bar-data-holder .right-holder .options .option.login-signup").toggleClass("active");
    $(".main-bar .main-bar-data-holder .right-holder .options .option.login-signup .login-overlay").toggleClass("show");
    $(".main-bar .main-bar-data-holder .right-holder .options .option.login-signup .login-popup").toggleClass("show");
  });
  $(document).on("click",".main-bar .main-bar-data-holder .right-holder .options .option.login-signup .login-popup", function(e){
    e.stopPropagation();
  });
  $(document).on("click",".login-popup .popup-form-holder form .forgot-password, .login-page .popup-form-holder form .forgot-password", function(e){
    $(this).closest(".login-left-holder").find(".popup-form-holder.login").toggleClass("show");
    $(this).closest(".login-left-holder").find(".popup-form-holder.recover").toggleClass("show");
  });
  // $(document).on("click",".main-bar .main-bar-data-holder .right-holder .options .option.login-signup .login-popup .popup-form-holder form button", function(e){
  //   e.preventDefault();
  //   // window.Shopify.recaptchaV3.addToken(this, "customer_login");
  //   $.ajax({method: "POST", url: "/account/register",contentType: "application/json", data: $(this).closest("form").serialize(), success: function(data){
  //   }});
  // });
}
function showChildMenuMobile(){
  $(document).on("click",".main-nav .main-nav-menu .menu-list .list-item .main-link", function(e){
    if($("body").width() < 1024){
      if($(this).closest(".list-item").find(".child-menu-list").length > 0){
        e.preventDefault();
        $(this).closest(".list-item").toggleClass("active");
      }
    }
  });
  $(document).on("click",".main-nav .main-nav-menu .menu-list .list-item .child-menu-list .child-list-item .child-link", function(e){
    if($("body").width() < 1024){
      if($(this).closest(".child-list-item").find(".grandchild-menu-list").length > 0){
        e.preventDefault();
        if($(this).hasClass("active")){
          $(this).closest(".child-list-item").find(".grandchild-menu-list").slideUp(200);
        }
        else{
          $(".grandchild-menu-list").slideUp(200);
          $(".main-nav .main-nav-menu .menu-list .list-item .child-menu-list .child-list-item .child-link").removeClass("active");
          $(this).closest(".child-list-item").find(".grandchild-menu-list").slideDown(200);
        }
        $(this).toggleClass("active");
      }
    }
  });
  $(document).on("click",".main-nav .main-nav-menu .menu-list .list-item .child-menu-list .child-list-item.go-back", function(e){
    $(".grandchild-menu-list").slideUp(200);
    $(this).closest(".list-item").removeClass("active");
  });
}
function clearMenuMobile(){
  $(".main-nav .main-nav-menu .menu-list .list-item .child-menu-list .child-list-item .child-link").removeClass("active");
  if($("body").width() < 1024){
    $(".grandchild-menu-list").slideUp(1);
  }
  else{
    $(".main-nav .main-nav-menu .menu-list .list-item").removeClass("active");
    $(".grandchild-menu-list").slideDown(1);
    $(".main-nav").removeClass("active")
    $(".main-bar .main-bar-data-holder .left-holder .menu-icon-holder").removeClass("active");
  }
}
function updateNoteandRedirectToCheckout(){
  $(document).on("click",".main-cart-holder .main-cart-data-holder .main-cart-checkout-button", async function(e){
    await updateFlashCartProperty(e);

    var cart_note = $(".main-cart-holder .main-cart-data-holder .right-cart-data-holder .order-instructions-holder textarea").val();
    var previous_cart_note = $(".main-cart-holder .main-cart-data-holder .right-cart-data-holder .order-instructions-holder textarea").data("val");
    var cart_attributes = {};
    cart_attributes["Date"] = "";
    cart_attributes["Time"] = "";
    cart_attributes["Delivery Time Start"] = "";
    cart_attributes["Delivery Time End"] = "";
    if(!$(".pickup-option.purchase-option").hasClass("active") && !$(".delivery-option.purchase-option").hasClass("active") && !$(".box-option.purchase-option").hasClass("active")){
      showNotification("How would you want this order?", "error");
      return;
    }
    if($(".pickup-option.purchase-option").hasClass("active")){
      if($(".date-picker").val() != ""){
        cart_attributes["Date"] = $(".date-picker").val();
      }
      else{
        showNotification("Please select a date for pickup!", "error");
        return;
      }
      if($(".time-picker").val() != ""){
        cart_attributes["Time"] = $(".time-picker").val();
      }
      else{
        showNotification("Please select a time for pickup!", "error");
        return;
      }
    }
    if($(".delivery-option.purchase-option").hasClass("active")){
      if($(".opening-time-picker").val() != ""){
        cart_attributes["Delivery Time Start"] = $(".opening-time-picker").val();
      }
      else{
        showNotification("Please select a start time for delivery!", "error");
        return;
      }
      if($(".closing-time-picker").val() != ""){
        cart_attributes["Delivery Time End"] = $(".closing-time-picker").val();
      }
      else{
        showNotification("Please select an end time for delivery!", "error");
        return;
      }
      if($("input[name='open-day']:checked").length != 0){
      	var days = [];
		document.querySelectorAll("input[name='open-day']:checked").forEach((element)=>{days.push(element.value);})
        cart_attributes["Delivery Days"] = days.join(", ");
      }
      else{
        showNotification("Please select at least one open day!", "error");
        return;
      }
    }
    if($(".box-option.purchase-option").hasClass("active")){
      if(window.non_shippables != ''){
        showNotification("Remove Non-Ship items from cart to checkout using Box Shipment!", "error");
        return;
      }
    }
    $.post('/cart/update.js', { note: cart_note, attributes: cart_attributes }, function(data){
      if(cart_attributes["Date"] != "" && cart_attributes["Time"] != ""){
        setCookie("a1-pickup-date",cart_attributes["Date"],1);
        setCookie("a1-pickup-time",cart_attributes["Time"],1);
        setCookie("a1-pickup-price",(data["total_price"]/100)+"",1);
      }
      else{
        setCookie("a1-pickup-date","",1);
        setCookie("a1-pickup-time","",1);
        setCookie("a1-pickup-price","",1);
      }
      if(cart_attributes["Delivery Time Start"] != "" && cart_attributes["Delivery Time End"] != "" && cart_attributes["Delivery Days"] != ""){
        setCookie("a1-delivery-start",cart_attributes["Delivery Time Start"],1);
        setCookie("a1-delivery-end",cart_attributes["Delivery Time End"],1);
        setCookie("a1-delivery-days",cart_attributes["Delivery Days"],1);
      }
      else{
        setCookie("a1-delivery-start","",1);
        setCookie("a1-delivery-end","",1);
        setCookie("a1-delivery-days","",1);
      }
      location.pathname = "/checkout";
    }, "json");
  });
}

function updateNoteandRedirectToCheckout2(){
  $(document).on("click",".main-cart-holder .main-cart-data-holder .main-cart-checkout-button", function(e){
    updateFlashCartProperty(e);
  });
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function bindContinueButton(){
  $(document).on("click",".main-cart-holder .continue-button-holder .continue-shopping", function(){
    location.href = document.referrer;
  });
}
function bindFiltersPopup(){
  $(document).on("click",".main-collection-section .top-holder-collection .right-section-collection .inner-right-holder .filter-button, .main-collection-section .bottom-holder-collection .left-section-collection .close-filters", function(){
    $(".main-collection-section .bottom-holder-collection .left-section-collection").toggleClass("show");
  });
  $(document).on("click",".account-right-holder.list .right-section-collection .inner-right-holder .filter-button, .main-account-page.list .left-section-collection .close-filters", function(){
    $(".main-account-page.list .left-section-collection").toggleClass("show");
  });
}
function bindCartQuantityButton(){
  $(document).on("click",".cart-popup-container .cart-middle-holder .line-item-holder .line-item .data-holder .line-bottom-holder .quantity-holder .quantity-button", function(){
    var increment = parseInt($(this).closest(".quantity-holder").find("input").data("increment-amount"));
    var quantity_value = parseInt($(this).closest(".quantity-holder").find("input").val());
    var max_value = $(this).closest(".quantity-holder").data("max");
    var true_max_value = $(this).closest(".quantity-holder").data("truemax");
    var line_variant_id = $(this).data("variant-id");
    if(max_value == null){
      max_value = Number.POSITIVE_INFINITY;
    }
    else{
      max_value = parseInt(max_value);
    }
    if(!/^\d+$/.test(quantity_value)){
      quantity_value = increment;
    }
    else{
      quantity_value = parseInt(quantity_value);
      if($(this).hasClass("up")){
        if(quantity_value + increment <= max_value){
          quantity_value+=increment;
        }
      }
      else if($(this).hasClass("down")){
        if(quantity_value - increment >= 0){
          quantity_value-=increment;
        }
      }
    }
    $(".cart-popup-container .overlay-holder").addClass("show");
    $.post('/cart/change.js', { quantity: quantity_value, id: parseInt(line_variant_id) }, function(){
      document.querySelectorAll("[id*='variant-"+line_variant_id+"']").forEach(function(variant){
        $(variant).data("added", quantity_value);
        $(variant).data("max", true_max_value - quantity_value);
      });
      var elements_1 = document.querySelectorAll(".products-holder .product-item .card-information .card-information__wrapper .bottom-holder .add-button-holder input");
      var elements_2 = document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder input");
      if(elements_1){
        elements_1.forEach(function(ele){
          $(ele).val("1");
        });
      }
      if(elements_2){
        elements_2.forEach(function(ele){
          $(ele).val("1");
        });
      }
      checkMax();
      reloadCartPopup();
    }, "json");
  });
  $(document).on("click",".main-cart-holder .main-cart-data-holder .left-cart-data-holder .list-items-holder .line-item .quantity-holder .quantity-button", function(){
    var increment = parseInt($(this).closest(".quantity-holder").find("input").data("increment-amount"));
    var quantity_value = parseInt($(this).closest(".quantity-holder").find("input").val());
    var max_value = $(this).closest(".quantity-holder").data("max");
    var true_max_value = $(this).closest(".quantity-holder").data("truemax");
    var line_variant_id = $(this).data("variant-id");
    if(max_value == null){
      max_value = Number.POSITIVE_INFINITY;
    }
    else{
      max_value = parseInt(max_value);
    }
    if(!/^\d+$/.test(quantity_value)){
      quantity_value = increment;
    }
    else{
      quantity_value = parseInt(quantity_value);
      if($(this).hasClass("up")){
        if(quantity_value + increment <= max_value){
          quantity_value+=increment;
        }
      }
      else if($(this).hasClass("down")){
        if(quantity_value - increment >= 0){
          quantity_value-=increment;
        }
      }
    }
    $(".main-overlay-holder").addClass("show");
    $.post('/cart/change.js', { quantity: quantity_value, id: parseInt(line_variant_id) }, function(){
      document.querySelectorAll("[id*='variant-"+line_variant_id+"']").forEach(function(variant){
        $(variant).data("added", quantity_value);
        $(variant).data("max", true_max_value - quantity_value);
      });
      var elements_1 = document.querySelectorAll(".products-holder .product-item .card-information .card-information__wrapper .bottom-holder .add-button-holder input");
      var elements_2 = document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder input");
      if(elements_1){
        elements_1.forEach(function(ele){
          $(ele).val("1");
        });
      }
      if(elements_2){
        elements_2.forEach(function(ele){
          $(ele).val("1");
        });
      }
      checkMax();
      reloadCart();
    }, "json");
  });
}

function bindCartQuantityInput(){
  $(document).on("keyup", ".cart-popup-container .cart-middle-holder .line-item-holder .line-item .data-holder .line-bottom-holder .quantity-holder input", function(){
    var increment = parseInt($(this).data("increment-amount"));
    var quantity_value = parseInt($(this).val());
    var max_value = $(this).closest(".quantity-holder").data("max");
    quantity_value = parseInt((quantity_value+"").replace(/[^0-9]/g, ''));
    if(max_value == null){
      max_value = Number.POSITIVE_INFINITY;
    }
    else{
      max_value = parseInt(max_value);
    }
    if(isNaN(quantity_value)){
      if($(this).val() != ""){
        quantity_value = increment;
        $(this).val(quantity_value+$(this).data("increment-unit"));
      }
    }
    else{
      if(quantity_value > max_value){
        quantity_value = parseInt(max_value/increment)*increment;
      }
      if(quantity_value < 1){
        quantity_value = increment;
      }
      else{
        quantity_value = parseInt(quantity_value/increment)*increment;
      }
      $(this).val(quantity_value+$(this).data("increment-unit"));
    }
  });
  $(document).on("focusout", ".cart-popup-container .cart-middle-holder .line-item-holder .line-item .data-holder .line-bottom-holder .quantity-holder input", function(quantity_input){
    if(parseInt($(this).data("current-quantity")) != (parseInt($(this).val()) ) ){
      var line_variant_id = $(this).data("variant-id");
      $(".cart-popup-container .overlay-holder").addClass("show");
      $.post('/cart/change.js', { quantity: isNaN(parseInt($(this).val())) ? 1 : parseInt($(this).val()), id: parseInt(line_variant_id) }, function(){
        reloadCartPopup();
      }, "json");
    }
  });
  $(document).on("keyup", ".main-cart-holder .main-cart-data-holder .left-cart-data-holder .list-items-holder .line-item .quantity-holder input", function(){
    var increment = parseInt($(this).data("increment-amount"));
    var quantity_value = parseInt($(this).val());
    var max_value = $(this).closest(".quantity-holder").data("max");
    quantity_value = parseInt((quantity_value+"").replace(/[^0-9]/g, ''));
    if(max_value == null){
      max_value = Number.POSITIVE_INFINITY;
    }
    else{
      max_value = parseInt(max_value);
    }
    if(isNaN(quantity_value)){
      if($(this).val() != ""){
        quantity_value = increment;
        $(this).val(quantity_value+$(this).data("increment-unit"));
      }
    }
    else{
      if(quantity_value > max_value){
        quantity_value = parseInt(max_value/increment)*increment;
      }
      if(quantity_value < 1){
        quantity_value = increment;
      }
      else{
        quantity_value = parseInt(quantity_value/increment)*increment;
      }
      $(this).val(quantity_value+$(this).data("increment-unit"));
    }
  });
  $(document).on("focusout", ".main-cart-holder .main-cart-data-holder .left-cart-data-holder .list-items-holder .line-item .quantity-holder input", function(quantity_input){
    if(parseInt($(this).data("current-quantity")) != (parseInt($(this).val()) ) ){
      var line_variant_id = $(this).data("variant-id");
      $(".main-overlay-holder").addClass("show");
      $.post('/cart/change.js', { quantity: isNaN(parseInt($(this).val())) ? 1 : parseInt($(this).val()), id: parseInt(line_variant_id) }, function(){
        reloadCart();
      }, "json");
    }
  });
}

function enabledLocationsCarousel(){
  if($(".slick-carousel-holder").length > 0){
    $(".slick-carousel-holder").slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      speed: 400,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: "<i class='icon-chevron-left left'></i>",
      nextArrow: "<i class='icon-chevron-right right'></i>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}

function toggleCitiesDropdown(){
  $(document).on("click", ".faq-question", function(){
    var has_class = $(this).closest(".faq-item").hasClass("show");
    $(".faq-item").removeClass("show");
    if(!has_class){
        $(this).closest(".faq-item").addClass("show");
        $(this).closest(".faq-item").find(".faq-answer").slideDown(200);
    }
    $(".faq-item:not(.show) .faq-answer").slideUp(200);
  });
}

function bindDeleteItemFromCartPopup(){
  $(document).on("click",".cart-popup-container .cart-middle-holder .line-item-holder .line-item .delete-button", function(){
    var line_variant_id = $(this).data("variant-id");
    $(".cart-popup-container .overlay-holder").addClass("show");
    $.post('/cart/change.js', { quantity: 0, id: parseInt(line_variant_id) }, function(){
      reloadCartPopup();
    }, "json");
  });
  $(document).on("click",".main-cart-holder .main-cart-data-holder .left-cart-data-holder .list-items-holder .line-item .actions .delete-button", function(){
    var line_variant_id = $(this).data("variant-id");
    $(".main-overlay-holder").addClass("show");
    $.post('/cart/change.js', { quantity: 0, id: parseInt(line_variant_id) }, function(){
      reloadCart();
    }, "json");
  });
}
function bindAddToCart(){
  $(document).on("click",".products-holder .product-item .card-information .card-information__wrapper .bottom-holder .add-button-holder .add_to_cart:not(.sold_out, .notify)", function(){
    var add_button = $(this);
    var button_data = "<span>ADD TO CART</span>";
    addLoader(add_button);
    add_button.toggleClass("disabled");
    var variant_id = $(this).closest(".bottom-holder").find(".variant-options-holder .variant-option input[type=radio]:checked").data("variant-id");
    var quantity = parseInt($(this).closest(".add-button-holder").find(".input-holder input[type=text]").val());
    var max = parseInt($(this).closest(".bottom-holder").find(".variant-options-holder .variant-option input:checked").data("truemax"));
    var added = parseInt($(this).closest(".bottom-holder").find(".variant-options-holder .variant-option input:checked").data("added"));
    if(location.pathname == "/cart"){
      $(".main-overlay-holder").toggleClass("show");
    }
    if(added < max){
      $.ajax({url: "/cart/add.js",contentType: "application/json",dataType: "json", data: {'items': [{ 'id': variant_id, 'quantity': quantity }]}, success: function(data){
        data.items.forEach(function(line_item){
          var message = '<b>'+line_item.title+'</b> added to cart!';
          showNotification(message, "message");
          reloadCartPopup();
        });
        added += quantity;
        document.querySelectorAll("[id*='variant-"+variant_id+"']").forEach(function(variant){
          $(variant).data("added", added);
          $(variant).data("max", max-added);
        });
        var elements_1 = document.querySelectorAll(".products-holder .product-item .card-information .card-information__wrapper .bottom-holder .add-button-holder input");
        var elements_2 = document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder input");
        if(elements_1){
          elements_1.forEach(function(ele){
            $(ele).val("1");
          });
        }
        if(elements_2){
          elements_2.forEach(function(ele){
            $(ele).val("1");
          });
        }
        if(added >= max){
          add_button.html("<span>LIMIT REACHED</span>");
        }
        else{
          add_button.toggleClass("disabled");
          add_button.html(button_data);
        }
        // checkFreeProducts();


        // checkfreeBasmitiProducts(data);


      },
      error: function(data){
        add_button.toggleClass("disabled");
        add_button.html(button_data);
        showNotification(data.responseJSON.description, "error");
        if(location.pathname == "/cart"){
          $(".main-overlay-holder").toggleClass("show");
        }
      }});
    }
    else{
      checkMax();
    }
  });

  $(document).on("click",".account-right-holder.order .list-items-holder .line-item .actions .add-to-cart:not(sold_out, .notify)", function(){
    var add_button = $(this);
    add_button.toggleClass("disabled");
    var variant_id = $(this).data("variant-id");
    var quantity = parseInt($(this).data("quantity"));
    $.ajax({url: "/cart/add.js",contentType: "application/json",dataType: "json", data: {'items': [{ 'id': variant_id, 'quantity': quantity }]}, success: function(data){
      add_button.toggleClass("disabled");
      data.items.forEach(function(line_item){
        var message = '<b>'+line_item.title+'</b> added to cart!';
        showNotification(message, "message");
        reloadCartPopup();
      });
      if(location.pathname == "/cart"){
        reloadCart();
      }
      reloadCartPopup();
    },
    error: function(data){
      add_button.toggleClass("disabled");
      showNotification(data.responseJSON.description, "error");
    }});
  });

  $(document).on("click",".notify-holder .notify-popup .notify-button", function(){
    var notify_button = $(this);
    var variant_id = $(".notify-holder .notify-popup .variant-selection-dropdown").val();
    var customer_email = $(".notify-holder .notify-popup .customer-email").val();
    var button_data = $(this).html();
    addLoader(notify_button);
    notify_button.toggleClass("disabled");
    $.ajax({url: "https://app.findfoodservice.ca/add_notify_customer", type: "POST" ,dataType: "json", data: {"shop": "a1cashandcarry.myshopify.com", "variant_id": variant_id, "email": customer_email}, success: function(data){
      showNotification(data.message, data.status);
      notify_button.toggleClass("disabled");
      notify_button.html(button_data);
    },
    error: function(data){
      showNotification(data.message, data.status);
      notify_button.toggleClass("disabled");
      notify_button.html(button_data);
    }});
  });

  $(document).on("click",".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder.primary .buttons-holder .add_to_cart.notify", function(){
    $(".notify-holder").addClass("show");
    product = window.shopify_product_data[$(this).data("product-id")];
    $(".notify-holder .notify-popup .product-title").text(product.title);
    variant_options = "";
    window.shopify_product_data[$(this).data("product-id")].variants.forEach(function(variant){variant_options += "<option value='"+variant.id+"'>"+variant.title+"</option>"});
    $(".notify-holder .notify-popup .variant-selection-dropdown").html(variant_options);
  });

  $(document).on("click",".notify-holder .notify-popup .close-notify-popup", function(){
    $(".notify-holder").removeClass("show");
  });

  $(document).on("click",".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder.primary .buttons-holder .add_to_cart:not(.sold_out, .notify)", function(){
    var add_button = $(this);
    var button_data = $(this).html();
    addLoader(add_button);
    add_button.toggleClass("disabled");
    var variant_id = $(this).closest(".main-actions-holder").find(".uom-selector .variant-options-holder .variant-option input[type=radio]:checked").data("variant-id");
    var max = $(this).closest(".main-actions-holder").find(".uom-selector .variant-options-holder .variant-option input[type=radio]:checked").data("truemax");
    var added = $(this).closest(".main-actions-holder").find(".uom-selector .variant-options-holder .variant-option input[type=radio]:checked").data("added");
    var quantity = parseInt($(this).closest(".action-holder").find(".quantity-holder input[type=text]").val());
    if(added < max){
      $.ajax({url: "/cart/add.js",contentType: "application/json",dataType: "json", data: {'items': [{ 'id': variant_id, 'quantity': quantity }]}, success: function(data){
        data.items.forEach(function(line_item){
          var message = '<b>'+line_item.title+'</b> added to cart!';
          showNotification(message, "message");
          reloadCartPopup();
        });
        added += quantity;
        document.querySelectorAll("[id*='variant-"+variant_id+"']").forEach(function(variant){
          $(variant).data("added", added);
          $(variant).data("max", max-added);
        });
        var elements_1 = document.querySelectorAll(".products-holder .product-item .card-information .card-information__wrapper .bottom-holder .add-button-holder input");
        var elements_2 = document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder .quantity-holder input");
        if(elements_1){
          elements_1.forEach(function(ele){
            $(ele).val("1");
          });
        }
        if(elements_2){
          elements_2.forEach(function(ele){
            $(ele).val("1");
          });
        }
        if(added >= max){
          add_button.html("<span>LIMIT REACHED</span>");
        }
        else{
          add_button.toggleClass("disabled");
          add_button.html(button_data);
        }
        // checkFreeProducts();
        // checkfreeBasmitiProducts(data)
      },
      error: function(data){
        add_button.toggleClass("disabled");
        add_button.html(button_data);
        showNotification(data.responseJSON.description, "error");
      }});
    }
  });

  $(document).on("click",".product-tiers .tier-discount-button", function(){
    var add_button = $(this);
    var button_data = $(this).html();
    addLoader(add_button);
    add_button.toggleClass("disabled");
    var variant_id = $(this).data("variant-id");
    var quantity = parseInt($(this).data("quantity"));
    $.ajax({url: "/cart/add.js",contentType: "application/json",dataType: "json", data: {'items': [{ 'id': variant_id, 'quantity': quantity }]}, success: function(data){
      add_button.toggleClass("disabled");
      add_button.html(button_data);
      data.items.forEach(function(line_item){
        var message = '<b>'+line_item.title+'</b> added to cart!';
        showNotification(message, "message");
      });
      reloadCartPopup();
    },
    error: function(data){
      add_button.toggleClass("disabled");
      add_button.html(button_data);
      showNotification(data.responseJSON.description, "error");
    }});
  });
  $(document).on("click",".notifications-holder .notification-item .close-notification", function(){
    if($(this)){
      $(this).closest(".notification-item").removeClass("show");
      setTimeout(function(element){
        element.remove();
      }, 200, $(this).closest(".notification-item"));
    }
  });
}

function checkMax(){
  var element_type_1 = document.querySelectorAll(".products-holder .product-item .card-information .card-information__wrapper .bottom-holder .add-button-holder .add_to_cart:not(.sold_out, .notify)");
  var element_type_2 = document.querySelectorAll(".product-info-holder .product-data-holder .right-data-holder .main-actions-holder .action-holder.primary .buttons-holder .add_to_cart:not(.sold_out, .notify)");
  if(element_type_1){
    element_type_1.forEach(function(element){
      var max = $(element).closest(".bottom-holder").find(".variant-options-holder .variant-option input:checked").data("truemax");
      var added = $(element).closest(".bottom-holder").find(".variant-options-holder .variant-option input:checked").data("added");
      if(added >= max){
        $(element).addClass("disabled");
        $(element).html("<span>LIMIT REACHED</span>");
      }
      else{
        if($(element).parents('.bottom-holder').find('input:checked').length>0 || $(element).parents('.main-actions-holder').find('input:checked').length>0){
          $(element).removeClass("disabled");
          $(element).html("<span>ADD TO CART</span>"); 
        }else{
          $(element).addClass("disabled");
          $(element).html("<span>LIMIT REACHED</span>");
        }
 
      }
    });
  }
  if(element_type_2){
    element_type_2.forEach(function(element){
      var max = $(element).closest(".main-actions-holder").find(".uom-selector .variant-options-holder .variant-option input[type=radio]:checked").data("truemax");
      var added = $(element).closest(".main-actions-holder").find(".uom-selector .variant-options-holder .variant-option input[type=radio]:checked").data("added");
      if(added >= max){
        $(element).addClass("disabled");
        $(element).html("<span>LIMIT REACHED</span>");
      }
      else{
        if($(element).parents('.bottom-holder').find('input:checked').length>0 || $(element).parents('.main-actions-holder').find('input:checked').length>0){
          $(element).removeClass("disabled");
          $(element).html("<span>ADD TO CART</span>"); 
        }else{
          $(element).addClass("disabled");
          $(element).html("<span>LIMIT REACHED</span>");
        }
      }
    });
  }
}

function showNotification(message, message_type="message"){
  var type = "";
  if(message_type == "error"){
    type = "error";
  }
  var date_val = Date.now();
  $(".notifications-holder").append('<div class="notification-item '+date_val+' '+type+'"> <div class="message">'+message+'</div> <div class="close-notification"><i class="icon-times"></i></div> </div>');
  $('.'+date_val).css("right",'-'+$('.'+date_val).width()+'px');
  setTimeout(function(date_vl){
    $('.'+date_vl).addClass("show");
    setTimeout(function(date_vl_1){
      if($('.'+date_vl_1)){
        $('.'+date_vl_1).removeClass("show");
      }
      setTimeout(function(date_vl_2){
        if($('.'+date_vl_2)){
          $('.'+date_vl_2).remove();
        }
      }, 200, date_vl_1);
    }, 5000, date_vl);
  }, 200, date_val);
}

function reloadCartPopup(){
  $(".cart-popup-container .overlay-holder").toggleClass("show");
  $.get("/?sections=cart-popup",function(data){
    $(".cart-popup-holder").html(data["cart-popup"]);
  });
}
function reloadCart(){
  $.get("/?sections=main-cart",function(data){
    $(".main-overlay-holder").removeClass("show");
    $(".main-cart-holder").html(data["main-cart"]);
  });
}

function addLoader(element){
  element.html("<div class='loader-ring'><div></div><div></div><div></div><div></div></div>");
}
function addLoaderSmall(element){
  element.html("<div class='loader-ring-small'><div></div><div></div><div></div><div></div></div>");
}

function enablePopupCart(){
  $(document).on("click",".main-bar .options .option.cart, .cart-popup-holder .cart-top-holder .close-cart",function(){
    if(location.pathname != "/cart"){
      $("body").toggleClass("disable-scroll");
      $(".cart-popup-holder").toggleClass("disabled");
    }
  });
}

function saveQueryParams(){
  // Save existing sort parameters
  if (typeof Shopify !== 'undefined') {
    Shopify.queryParams = {};
    if(location.search.length) {
      for(var aKeyValue, i = 0, aCouples = location.search.replaceAll("+"," ").substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }    
  }

}

function enableSort(){
  if(document.querySelector('.sort-by')){
    // Add existing sort parameters to current URL
    document.querySelector('.sort-by').addEventListener('change', function(e) {
      var value = e.currentTarget.value;
      Shopify.queryParams["page"] = 1;
      Shopify.queryParams.sort_by = value;
      var search = new URLSearchParams(Shopify.queryParams).toString();
      location.search = search.replaceAll("%2C",",");
    });
  }
}

function enableMobileSearch(){
  $(".mobile-search-bar-holder").show();
  $(".mobile-search-bar-holder").slideUp(1);
  $(".main-bar .options .option.search").on("click",function(){
    $(this).toggleClass("active");
    $(".main-bar .middle-holder").toggleClass("show-mobile");
    if($(this).hasClass("active")){
      $(".mobile-search-bar-holder").slideDown(300);
    }
    else{
      $(".mobile-search-bar-holder").slideUp(300);
    }
  });
}

function enableMainBanner(){
  // $(".main-banner .banner-images").removeClass("not-slick");
  // $(".main-banner .banner-images").show();
  if($(".banner-images").length > 0){
    $(".banner-images").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      speed: 400,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: "<i class='icon-chevron-left left'></i>",
      nextArrow: "<i class='icon-chevron-right right'></i>"
    });
  }
}

function enableSalesCollectionProductsScroll(){
  if($(window).width() > 1023){
    $(".collection-holder.sales").addClass("enable-slick");
    if($(".collection-holder.sales .products-holder").length > 0 && !$(".collection-holder.sales .products-holder").hasClass("slick-slider")){
      $(".collection-holder.sales .products-holder").slick({
        infinite: false,
        slidesToShow: $(".collection-holder.sales .products-holder").data("slides-to-show"),
        slidesToScroll: 2,
        dots: false,
        speed: 400,
        arrows: true,
        prevArrow: "<i class='icon-chevron-left left'></i>",
        nextArrow: "<i class='icon-chevron-right right'></i>"
      });
    }
  }
  else if($(".collection-holder.sales .products-holder").hasClass("slick-slider")){
    $(".collection-holder.sales").removeClass("enable-slick");
    $(".collection-holder.sales .products-holder").slick("unslick");
  }
}

function enableCollectionIconsScroll(){
  if($(".top-icons-holder .top-icons").length > 0){
    $(".top-icons-holder .top-icons").addClass("enable-slick");
    $(".top-icons-holder .top-icons").slick({
      infinite: true,
      slidesToShow: 8,
      slidesToScroll: 1,
      dots: false,
      speed: 400,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: "<i class='icon-chevron-left left'></i>",
      nextArrow: "<i class='icon-chevron-right right'></i>",
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToShow: 7
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 890,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }
}

function enableAboutUsLocationScroll(){
  if($(".about-us-page .intro-section .location-slider").length > 0){
    $(".about-us-page .intro-section .location-slider").addClass("enable-slick");
    $(".about-us-page .intro-section .location-slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      speed: 400,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: "<i class='icon-chevron-left left'></i>",
      nextArrow: "<i class='icon-chevron-right right'></i>",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
}

function businessCategoryChange(){
  $(document).on("change","select[name='customer[note][business_category]']",function(){
    var new_options = "<option value='' selected>Business Sub Category</option>";
    if(this.value != ""){
      var values = globalDropdownOptions[this.value];
      values.forEach(function(value){
        new_options += "<option value='"+value+"'>"+value+"</option>";
      });
    }
    $("select[name='customer[note][business_sub_category]']").html(new_options);
  });
}

function enableProductImagesScroll(){
  if($(".product-info-holder .product-data-holder .left-data-holder .product-images-holder").length > 0){
    $(".product-info-holder .product-data-holder .left-data-holder .product-images-holder").addClass("enable-slick");
    $(".product-info-holder .product-data-holder .left-data-holder .product-images-holder").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      fade: true,
      cssEase: 'linear',
      speed: 300,
      arrows: true,
      adaptiveHeight: true,
      autoplay: false,
      prevArrow: "<i class='icon-chevron-left left'></i>",
      nextArrow: "<i class='icon-chevron-right right'></i>"
    });
    $(".product-info-holder .product-data-holder .left-data-holder .product-images-holder .product-image.slick-active").zoom(2);
    $(".product-zoom-holder").width($(".product-info-holder .product-data-holder .left-data-holder .product-images-holder .product-image.slick-current").width());
    $(".product-zoom-holder").height($(".product-info-holder .product-data-holder .left-data-holder .product-images-holder .product-image.slick-current").height());
    $(document).on("click",".product-info-holder .product-data-holder .left-data-holder .product-selector-images .product-selector-image",function(){
      $(".product-info-holder .product-data-holder .left-data-holder .product-images-holder").slick("slickGoTo", parseInt($(this).data("index"))-1, false);
    });
    $(document).on("beforeChange",".product-info-holder .product-data-holder .left-data-holder .product-images-holder",function(event, slick, currentSlide, nextSlide){
      var next_slide = $(".product-info-holder .product-data-holder .left-data-holder .product-images-holder .product-image[data-slick-index="+nextSlide+"]");
      $(".product-zoom-holder .product-zoom-image").removeClass("active");
      $(".product-info-holder .product-data-holder .left-data-holder .product-selector-images .product-selector-image").removeClass("active");
      $(".product-info-holder .product-data-holder .left-data-holder .product-selector-images .product-selector-image[data-index="+next_slide.data("index")+"]").addClass("active");
      $(".product-zoom-holder .product-zoom-image[data-index="+next_slide.data("index")+"]").addClass("active");
      next_slide.zoom(2);
      $(".product-zoom-holder").width(next_slide.width());
      $(".product-zoom-holder").height(next_slide.height());
    });
  }
}

function enableBrandsScroll(){
  if($(".brands-section .brands-holder").length > 0){
    // $(".brands-section .brands-holder").addClass("enable-slick");
    $(".brands-section .brands-holder").slick({
      infinite: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      speed: 400,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: "<i class='icon-chevron-left left'></i>",
      nextArrow: "<i class='icon-chevron-right right'></i>",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });
  }
}

function enableRecommendedScroll(){
  if($(window).width() > 1023){
    $(".collection-holder.recommended").addClass("enable-slick");
    if($(".collection-holder.recommended .products-holder").length > 0 && !$(".collection-holder.recommended .products-holder").hasClass("slick-slider")){
      $(".collection-holder.recommended .products-holder").slick({
        infinite: false,
        slidesToShow: $(".collection-holder.recommended .products-holder").data("slides-to-show"),
        slidesToScroll: 2,
        dots: false,
        speed: 400,
        arrows: true,
        prevArrow: "<i class='icon-chevron-left left'></i>",
        nextArrow: "<i class='icon-chevron-right right'></i>",
        responsive: [
          {
            breakpoint: 1390,
            settings: {
              slidesToShow: 5
            }
          }
        ]
      });
    }
  }
  else if($(".collection-holder.recommended .products-holder").hasClass("slick-slider")){
    $(".collection-holder.recommended").removeClass("enable-slick");
    $(".collection-holder.recommended .products-holder").slick("unslick");
  }
}

function enableTestimonialsScroll(){
  if($(".testimonials-holder").length > 0){
    $(".testimonials-holder").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      centerMode: true,
      centerPadding: "380px",
      speed: 400,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 8000,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            centerPadding: "300px"
          }
        },
        {
          breakpoint: 1024,
          settings: {
            centerPadding: "23.4vw"
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            centerPadding: "0"
          }
        }
      ]
    });
  }
}

function bind(){
  bindReloadEvents();
  // bindSearchDropdown();
  resizeBind();
}

function resizeBind(){
  $(window).on('resize', function() {
    enableSalesCollectionProductsScroll();
    enableRecommendedScroll();
    clearMenuMobile();
    clearAccountMenu();
  });
}

function bindReloadEvents(){
  document.addEventListener("shopify:section:load", function(){
    enableMainBanner();
  });
}
function bindSearchDropdown(){
  document.getElementById('search-product-type').onchange = function () {
    value = document.getElementById('search-product-type').value;
    if(value == ''){
      value = "All Categories";
    }
    this.previousElementSibling.querySelector('.search-bar__filter-active').innerHTML = value;
  }
}

function checkFreeProducts(){
  $.getJSON('/cart.js', function(data){
  var remove_list = {'updates':{}};
  data.items.forEach(function(line_item){
    if(line_item.line_price == 0){
      remove_list['updates'][line_item.variant_id] = 0;
    }
  });
  if(!$.isEmptyObject(remove_list['updates'])){
    $.post('/cart/update.js', remove_list, function(){
      if(location.pathname == "/cart"){
        $(".main-overlay-holder").addClass("show");
        reloadCart();
      }
      reloadCartPopup();
    }, "json");
  }
  else{
    if(location.pathname == "/cart"){
      $(".main-overlay-holder").addClass("show");
      reloadCart();
    }
    reloadCartPopup();
  }
});
}

(function () {

  if (typeof $ !== "function")
    throw Error('JQuery is not present.');

  var times = 2, handler;

  var init = function () {

    var t = $(this),
      p = t.closest(".left-data-holder"),
      v = p.find(".product-zoom-holder"),
      cs = p.find(".magnifier"),
      iw = v.find(".product-zoom-image[data-index="+t.data("index")+"]");

    handler = function (e) {

      var [w, h] = ['width', 'height'].map(x => $.fn[x].call(t)), nw = w * times, nh = h * times, cw = w / times, ch = h / times;

      var eventMap = {
        mousemove: function (e) {
          e = e.originalEvent;
          var x = e.layerX;
          if($(e.target).hasClass("right")){
            x += $(".product-info-holder .product-data-holder .left-data-holder .product-images-holder .product-image.slick-current").width();
          }
          var y = e.layerY,
             rx = cw / 2,
             ry = ch / 2,
             cx = x - rx,
             cy = y - ry,
             canY = cy >= 0 && cy <= h - ch,
             canX = cx >= 0 && cx <= w - cw;
          // console.log("x: "+x+"\ny: "+y+"\ncx: "+cx+"\nw: "+w+"\ncw: "+cw);
          cs.css({
            top: canY ? cy : cy < 0 ? 0 : h - ch,
            left: canX ? cx : cx < 0 ? 0 : w - cw
          });

          iw.css({
            top: canY ? -cy / (h - ch) * (nh - h) : cy < 0 ? 0 : -(nh - h),
            left: canX ? -cx / (w - cw) * (nw - w) : cx < 0 ? 0 : -(nw - w)
          });
        }
      };

      // p.width(w).height(h);
      cs.width(cw).height(ch);
      iw.width(nw).height(nh);

      for (let k in eventMap)
        p.on(k, eventMap[k]);
    };

    t.one('load', handler).each(function() {
      if(this.complete) {
        // $(this).load(); // For jQuery < 3.0 
        $(this).trigger('load'); // For jQuery >= 3.0 
      }
    });
  };

  $.fn.extend({

    zoom: function (t) {
      times = t || times;

      for (let x of this)
        init.call(x);

      return this;
    },
    setZoom: function (t) {

      times = t || times;

      if (handler === void 0)
        throw Error('Zoom not initialized.');

      handler();

    }

  });

}());

const a1c_cart_overlay=document.querySelector('.cart-popup-holder');
if(a1c_cart_overlay){
a1c_cart_overlay.addEventListener('click',function(e){
    if(e.target.className =='cart-popup-holder'){
        if(location.pathname != "/cart"){
          $("body").toggleClass("disable-scroll");
          $(".cart-popup-holder").toggleClass("disabled");
        }
    }
})
}

// if($('[name="customer[note][account_type]').length>0){
//   $('[name="customer[note][account_type]').on('change',function(){
//     if($('#online_instore:checked').length>0){
//         document.querySelector('#RegisterForm-business_name').setAttribute('required',true);
//         document.querySelector('#RegisterForm-business_name').setAttribute('aria-required',true);
//         document.querySelector('#RegisterForm-business_name').placeholder='Business Name*';
//     }else{
//         document.querySelector('#RegisterForm-business_name').placeholder='Business Name';
//         document.querySelector('#RegisterForm-business_name').removeAttribute('aria-required');
//         document.querySelector('#RegisterForm-business_name').removeAttribute('required');
//     }
//   })
// }

// var all_bulk_country_span = document.querySelectorAll('.delivery-form .input-field-holder span');
// if(all_bulk_country_span.length>0){
//   for(var k=0;k<all_bulk_country_span.length;k++){
//     all_bulk_country_span[k].addEventListener('click',function(e){
//         this.parentElement.querySelector('input').click()
//     })  
//   }  
// }

 // 

function a1_show_cities(current_element){
    let current_name = current_element.value.toLowerCase();

    document.querySelectorAll('.selected-cities .cities-name li').forEach(function(cities) {
        let current_city_name = cities.innerText.toLowerCase();
        if(current_city_name.includes(current_name)) {
            cities.classList.add('visible');
        } else {
            cities.classList.remove('visible');
        }
    });

    updateLiStyles(); // Call the function to update styles after updating visibility
}


function updateLiStyles() {
    let visibleCount = 0; // Counter for visible li elements

    document.querySelectorAll('.selected-cities .cities-name li.visible').forEach(function(li) {
        visibleCount++;
        li.style.backgroundColor = ""; // Reset the background color
        // Apply the style to visible li elements based on the pattern
        if ((visibleCount % 6 >= 4 && visibleCount % 6 <= 6) || visibleCount % 6 == 0) {
            li.style.backgroundColor = "#f0f0f0"; // Set to desired background color
        }
    });
}



// description list cities shown
function toggleVisibility(id,current_element) {
    current_element.preventDefault();
    var element = document.getElementById(id);
    if (element.style.display === 'none') {
        element.classList.add('open');
        element.style.display = 'block';
        event.target.innerText = "Hide Cities";
    } else {
        element.classList.remove('open');
        element.style.display = 'none';
        event.target.innerText = "View Cities";
    }
}



function isPostalCode(value) {
  const regex = /^[A-Za-z]\d[A-Za-z]/;
  return regex.test(value);
}

function createRegexForPostalCodeCharCount(charCount) {
  // Start with a letter
  let pattern = '^[A-Za-z]';
  
  // Add characters based on even/odd positions, with a special case for a space after the 3rd character
  for (let i = 1; i < charCount; i++) {
    if (i === 3) {
      // Optionally allow a space after the 3rd character (before adding the 4th character)
      pattern += '(\\s)?';
    }
    pattern += i % 2 === 0 ? '[A-Za-z]' : '\\d';
  }
  
  pattern += '$';
  return new RegExp(pattern, 'i'); // Add 'i' flag here for case-insensitive matching
}


function handleCitySearchInput(event) {
    let current_value = event.target.value.toLowerCase();
    let isPostalCodeValue = createRegexForPostalCodeCharCount(current_value.replace(' ', '').length).test(current_value.replace(' ', ''));
    let city_not_found = true;
    let postal_value = current_value.slice(0, 3);
    document.querySelectorAll('.a1-cities-details').forEach(function(a1_cities_details) {
        let current_postal_code = a1_cities_details.querySelectorAll('p')[0].innerText.toLowerCase();
        let current_city = a1_cities_details.parentElement.querySelector('.city-label').innerText.toLowerCase();
        if ((current_postal_code.includes(postal_value) && isPostalCodeValue) || current_city.includes(current_value)) {
            if (current_value == "") {
                a1_cities_details.parentElement.style.display = "none";
                a1_cities_details.parentElement.querySelector('input').checked = false;
                document.querySelector('.select-citie-v2s').classList.add('select-citie-v2s-hide-border');
            } else {
                city_not_found =  false;
                a1_cities_details.parentElement.style.display = "block";
                a1_cities_details.parentElement.querySelector('input').checked = true;
                document.querySelector('.select-citie-v2s').classList.remove('select-citie-v2s-hide-border');
            }
        } else {
            a1_cities_details.parentElement.querySelector('input').checked = false;
            a1_cities_details.parentElement.style.display = "none";
        }
    });

  if(city_not_found && current_value.length>0){
    document.querySelector('.empty-a1-cities-name-update-li-v2').style.display='block';
  }else{
    document.querySelector('.empty-a1-cities-name-update-li-v2').style.display='none';
  }
}


function addFreeProductToCart(productId,quantity) {
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: productId,
      quantity: quantity,
    }),
  })
    .then(response => response.json())
    .then(data => {
        var message = 'Your Free <b>'+data.title+'</b> added to cart!';
        showNotification(message, "message");
        reloadCartPopup();
    })
}

function checkfreeBasmitiProducts(data) {
    const collectionHandle = 'bulk-basmati-rice-wholesale';
    const targetProductId = data.items[0].handle; // Assuming this is set correctly earlier
    const targetProductquantity = data.items[0].quantity; // Assuming this is set correctly earlier
    const getfreeproductid = 42812567093409; // Ensure this is a valid product variant ID
    const productsInCollectionUrl = `/collections/${collectionHandle}/products.json`;
    var added_quantity = data.items[0].quantity;
    fetch(productsInCollectionUrl)
      .then(response => response.json())
      .then(data => {
        let productFound = false;
  
        data.products.forEach(product => {
          const productId = product.handle;
          if (productId === targetProductId ) {
            checkCartItems(getfreeproductid,added_quantity)
            productFound = true;
            return; // Exit loop early if a match is found
          }
        });
  
        if (!productFound) {
          // console.log(`Product ID ${targetProductId} not found in the collection.`);
        }
      })
      .catch(error => console.error('Error fetching products:', error));
  
}


function checkCartItems(getfreeproductid,added_quantity){
  
  if(added_quantity>3){
    added_quantity = 3;
  }
  $.getJSON('/cart.js', function(data){
    let add_product = true;
    for(item in data.items){
      let current_item = data.items[item];
      if(current_item.variant_id == getfreeproductid && current_item.quantity >= 3){
         add_product = false;
      }else if(current_item.variant_id == getfreeproductid && current_item.quantity > 0 && (current_item.quantity + added_quantity)>3){
        added_quantity = added_quantity - current_item.quantity;
      }
    }
    if(add_product){
      addFreeProductToCart(getfreeproductid,added_quantity);
    }
  })
}

// custom-theme js 
document.querySelector("body").addEventListener("click", function (e) {
  if (e.target.matches(".recommended-products-section-custom .card-information .card-information__wrapper .quantity-buttons-holder .quantity-button") || e.target.matches(".account-right-holder .card-information .card-information__wrapper .quantity-buttons-holder .quantity-button") || e.target.matches(".recommended-similar-collection .card-information .card-information__wrapper .quantity-buttons-holder .quantity-button")) {
    if(document.querySelector(".recommended-products-section-custom .card-information .card-information__wrapper .add-button-holder .input-holder input") || document.querySelector(".account-right-holder .card-information .card-information__wrapper .add-button-holder .input-holder input") || document.querySelector(".recommended-similar-collection .card-information .card-information__wrapper .add-button-holder .input-holder input")){
        var increment = parseFloat(e.target.closest(".input-holder").querySelector("input").getAttribute("data-increment-amount"));
        var quantity_value = parseInt(parseInt(e.target.closest(".input-holder").querySelector("input").value)/increment);
        var unit = e.target.closest(".input-holder").querySelector("input").getAttribute("data-increment-unit");
        var max_value = $(e.target.closest(".bottom-holder").querySelector(".variant-options-holder .variant-option input:checked")).data("max");
        if(max_value == null){
          max_value = Number.POSITIVE_INFINITY;
        }
        else{
          max_value = parseInt(max_value);
        }
        quantity_value = parseFloat(quantity_value);
        if(!/^\d+$/.test(quantity_value)){
          quantity_value = 1;
        }
        else{
          quantity_value = parseInt(quantity_value);
          if(e.target.classList.contains("up")){
            if(quantity_value + 1 <= max_value){
              quantity_value++;
            }
          }
          else if(e.target.classList.contains("down")){
            if(quantity_value - 1 > 0){
              quantity_value--;
            }
          }
        }
        e.target.closest(".input-holder").querySelector("input").value = (quantity_value*increment)+unit;
    }
  }
});


if($('.info-cards-container-v2')){
  if(window.innerWidth<768){
    $('.info-cards-container-v2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: '90px',
    })
  }
}


if($(".slick-carousel-holder-v1").length > 0){
  $(".slick-carousel-holder-v1").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    speed: 400,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: "<i class='icon-chevron-left left'></i>",
    nextArrow: "<i class='icon-chevron-right right'></i>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
if($(".slick-carousel-holder-v2").length > 0){
  $(".slick-carousel-holder-v2").slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    adaptiveHeight: true,
    speed: 400,
    arrows: true,
    autoplay: true,
    centerPadding: '60px',
    autoplaySpeed: 4000,
    prevArrow: "<i class='icon-chevron-left left'></i>",
    nextArrow: "<i class='icon-chevron-right right'></i>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
}

if($(".slick-carousel-holder-v3").length > 0){
  $(".slick-carousel-holder-v3").slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    adaptiveHeight: true,
    speed: 400,
    arrows: true,
    autoplay: true,
    centerPadding: '60px',
    autoplaySpeed: 4000,
    prevArrow: "<i class='icon-chevron-left left'></i>",
    nextArrow: "<i class='icon-chevron-right right'></i>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
}


if($(".testimonials-holder-2").length > 0){
  $(".testimonials-holder-2").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    centerPadding: "420px",
    speed: 400,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          centerPadding: "300px"
        }
      },
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "23.4vw"
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0"
        }
      }
    ]
  });
}

if($('.flyer-first-half-container')){
  $('.flyer-first-half-container').slick({
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    prevArrow: "<i class='icon-chevron-left left'></i>",
    nextArrow: "<i class='icon-chevron-right right'></i>",
    slidesToScroll: 1
  });
}


window.addEventListener("load", function() {
  if(document.getElementById('burligton-container-form')){
    const form = document.getElementById('burligton-container-form');
    form.addEventListener("submit", function(e) {
      let formData = new FormData();
      let Email = document.querySelector('#ContactForm-email').value;
      let Name = document.querySelector('#ContactForm-name').value;
      let Phone = document.querySelector('#ContactForm-phone_number').value;
      let bodyData = document.querySelector('#ContactForm-body').value;
      let Business = document.querySelector('#ContactForm-business_name').value;
      formData.append('Email',Email);
      formData.append('Name',Name);
      formData.append('Phone',Phone);
      formData.append('Body',bodyData);
      formData.append('Business Name',Business);
      
      const action = "https://script.google.com/macros/s/AKfycbxdebtJLP2g75i0bwxa9kbEMZKpgXKBRMchjDgRa20R3TvcUkrNebjCigLJxDQ6GMtH/exec";
      fetch(action, {
        method: 'POST',
        body: formData,
      })
      .then(() => {
        alert("Success!");
      })
    });
  }
  
});


async function updateFlashCartProperty(e){
  e.preventDefault();
  $.getJSON('/cart.js', function (data) {
    const cartAttributes = {}; // Ensure cart_attributes is initialized

    // Filter cart items based on flashVariantIds
    const filteredItems = data.items.filter(cartItem => 
      flashVariantIds.includes(cartItem.id.toString())
    );

    // If matching items are found, update cart attributes
    if (filteredItems.length > 0) {
      cartAttributes["Flash Sale"] = "1";

      $.post('/cart/update.js', { attributes: cartAttributes }, function (response) {
        console.log("Cart updated successfully:", response);
        window.location.href="/checkout";
        return;
      }).fail(function (error) {
        console.error("Failed to update cart:", error);
        window.location.href="/checkout";
      }); 
    }else{
      cartAttributes["Flash Sale"] = null;

      $.post('/cart/update.js', { attributes: cartAttributes }, function (response) {
        console.log("Cart updated successfully:", response);
        window.location.href="/checkout";
      }).fail(function (error) {
        console.error("Failed to update cart:", error);
        window.location.href="/checkout";
      }); 
    }
  }).fail(function (error) {
    console.error("Failed to fetch cart data:", error);
    window.location.href="/checkout";
  });
}


if($('.multi-vendor-slider-content')){
  $('.multi-vendor-slider-content').slick({
    infinite: true,
    prevArrow: "<i class='icon-chevron-left left'></i>",
    nextArrow: "<i class='icon-chevron-right right'></i>",
    rows: 3,
    slidesPerRow: 7,
    responsive: [
      {
        breakpoint: 786,
        settings: {
          rows: 2,
          slidesPerRow: 3
        }
      },
    ] 
  });
}


 // Custom Image With Text Slider
    if(window.outerWidth < 786){
       $(".custom-image-with-text-content").slick({
        arrows: true,
        dots: true,
        infinite: true,
        fade: true,
        adaptiveHeight: true, 
        autoplay: false,
        appendDots: $(".dots-invertible-new-"),
        prevArrow: $(".custom-text-image-slider-content .prev-invertible"),
        nextArrow: $(".custom-text-image-slider-content .next-invertible"),
        asNavFor: ".custom-image-with-text-numbers,.custom-image-with-text-img,.custom-image-with-text-img-mobile",
       });
    }else{
       $(".custom-image-with-text-content").slick({
        arrows: true,
        fade: true,
        dots: true,
        adaptiveHeight: true,
        infinite: true,
        autoplay: false,
        appendDots: $(".dots-invertible-new-"),
        prevArrow: $(".custom-text-image-slider-content .prev-invertible"),
        nextArrow: $(".custom-text-image-slider-content .next-invertible"),
        asNavFor: ".custom-image-with-text-numbers,.custom-image-with-text-img,.custom-image-with-text-img-mobile",
       });
    }
  
    if(window.outerWidth < 786){
      $(".custom-image-with-text-img").slick({
        arrows: false,
        dots: false,
        adaptiveHeight: true, 
        infinite: true,
        autoplay: false,
       lazyLoad: 'ondemand',
        fade: true,
        asNavFor: ".custom-image-with-text-content,.custom-image-with-text-numbers",
      });
    }else{
      $(".custom-image-with-text-img").slick({
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        infinite: true,
        autoplay: false,
       lazyLoad: 'ondemand',
        fade: true,
        asNavFor: ".custom-image-with-text-content,.custom-image-with-text-numbers",
      });
    }
  
    $(".custom-image-with-text-numbers").slick({
      arrows: false,
      dots: false,
      infinite: true,
      adaptiveHeight: true,
      autoplay: false,
      fade: true,
      asNavFor: ".custom-image-with-text-content,.custom-image-with-text-img,.custom-image-with-text-img-mobile",
    });

  //  We deliver second section Scroll on mobile

 if ($('.WD-choose-us').length > 0) {
    if (window.innerWidth < 769) {
      $('.WD-choose-us').slick({
        slidesToShow: 3,
        slidesToScroll: 2,
        autoplay: true,
        speed: 500,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '90px',
        responsive: [
          {
            breakpoint: 530,
            settings: {
              slidesToShow: 2, 
              centerMode: false,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }



  

